import React, { useState, useRef, useEffect } from "react";
import _ from "lodash";
import Loader from "../../../../Components/UiComponents/Loader";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import { getEmailSelectionSlot, saveEmailNotification } from "../../../../Services/userService";
import CheckboxElement from "../../../../Components/UiComponents/CheckboxElement";
import { useNavigate } from "react-router-dom";

const EmailNotifications = (props) => {
    const [loading, setLoading] = useState(false);
    const [emailObject, setEmailObject] = useState(null);
    const navigate = useNavigate()
    const [myAccount, setMyAccount] = useState({
        myResponsibilities: {
            "Daily": false,
            "Weekly": false,
            "Monthly": false,
            "When_Recived": false,
            "Week_Before_Due": false,
            "Day_Before_Due": false
        },
        roleResponsibilities: {
            "Daily": false,
            "Weekly": false,
            "Monthly": false,
            "When_Recived": false,
            "Week_Before_Due": false,
            "Day_Before_Due": false
        },
        clientInitiativeActions: {
            "Daily": false,
            "Weekly": false,
            "Monthly": false,
            "When_Recived": false,
            "Week_Before_Due": false,
            "Day_Before_Due": false
        },
        documentManagement: {
            "Daily": false,
            "Weekly": false,
            "Monthly": false,
            "When_Recived": false,
            "Week_Before_Due": false,
            "Day_Before_Due": false
        }
    });

    var enduser = localStorage.getItem("enduser");
    if (enduser) {
        var tmpData = JSON.parse(enduser);
        if (tmpData === null) {
            navigate("/login")
            localStorage.clear()
        }
    }

    const toastRef = useRef();

    useEffect(() => {
        getEmailSelection()
    }, []);

    const getEmailSelection = async () => {
        try {
            if (tmpData === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            var emailData = await getEmailSelectionSlot(tmpData.userid)
            if (emailData && emailData.data) {
                if (emailData.data.success) {
                    var allObjects = {}
                    allObjects.myResponsibilities = emailData.data.data[0].myResponsibilities;
                    allObjects.roleResponsibilities = emailData.data.data[0].roleResponsibilities;
                    allObjects.clientInitiativeActions = emailData.data.data[0].clientInitiativeActions;
                    allObjects.documentManagement = emailData.data.data[0].documentManagement;
                    var emailObjectId = emailData.data.data[0]._id;
                    setMyAccount(allObjects)
                    setEmailObject(emailObjectId)
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const checkResponsibility = (check, key, field) => {
        setMyAccount((prevAccount) => ({
            ...prevAccount,
            [field]: {
                ...prevAccount[field],
                [key]: check
            }
        }));
    };

    const saveEmailNotifications = async () => {
        try {
            if (tmpData === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            var data = {
                myResponsibilities: myAccount.myResponsibilities,
                roleResponsibilities: myAccount.roleResponsibilities,
                clientInitiativeActions: myAccount.clientInitiativeActions,
                documentManagement: myAccount.documentManagement
            }
            var savedData = await saveEmailNotification(tmpData.customer, tmpData.userid, tmpData.email, emailObject, tmpData.role, data)
            if (savedData && savedData.data) {
                if (savedData.data.success) {
                    toastRef.current.showToast({
                        type: 'success',
                        message: savedData.data.message
                    });
                }
                else {
                    toastRef.current.showToast({
                        type: 'error',
                        message: savedData.data.message
                    });
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="data-submit">
                {
                    <div className="group-table-data mt-10">
                        <table className="group-datatable usagelog">
                            <thead className="group-table-header">
                                <tr>
                                    <th colSpan={7}>Ability</th>
                                </tr>
                                <tr>
                                    <th className="checkbox-header w-20"></th>
                                    <th className="width-10">Daily</th>
                                    <th className="width-10">Weekly</th>
                                    <th className="width-10">Monthly</th>
                                    <th className="width-10">When Received</th>
                                    <th className="width-10">Week Before Due</th>
                                    <th className="width-10">Day Before Due</th>
                                </tr>
                            </thead>
                            <tbody className="group-table-row">
                                {
                                    <React.Fragment>
                                        <tr>
                                            <td className="w-20">
                                                <label>My Responsibilities</label>
                                            </td>
                                            {
                                                Object.entries(myAccount.myResponsibilities).map(([key, index]) => (
                                                    <td key={key} className="width-10">
                                                        <CheckboxElement
                                                            checked={myAccount.myResponsibilities[key]}
                                                            onChangeCheck={(e) => checkResponsibility(e.checked, key, 'myResponsibilities')}
                                                            className="mr-2"
                                                        />
                                                    </td>
                                                ))
                                            }
                                        </tr>
                                        <tr>
                                            <td className="w-20">
                                                <label>Role Responsibilities</label>
                                            </td>
                                            {
                                                Object.entries(myAccount.roleResponsibilities).map(([key, index]) => (
                                                    <td key={key} className="width-10">
                                                        <CheckboxElement
                                                            checked={myAccount.roleResponsibilities[key]}
                                                            onChangeCheck={(e) => checkResponsibility(e.checked, key, 'roleResponsibilities')}
                                                            className="mr-2"
                                                        />
                                                    </td>
                                                ))
                                            }
                                        </tr>
                                        <tr>
                                            <td className="w-20">
                                                <label>Client Initiative Actions</label>
                                            </td>
                                            {
                                                Object.entries(myAccount.clientInitiativeActions).map(([key, index]) => (
                                                    <td key={key} className="width-10">
                                                        <CheckboxElement
                                                            checked={myAccount.clientInitiativeActions[key]}
                                                            onChangeCheck={(e) => checkResponsibility(e.checked, key, 'clientInitiativeActions')}
                                                            className="mr-2"
                                                        />
                                                    </td>
                                                ))
                                            }
                                        </tr>
                                        <tr>
                                            <td className="w-20">
                                                <label>Document Management</label>
                                            </td>
                                            {
                                                Object.entries(myAccount.documentManagement).map(([key, index]) => (
                                                    <td key={key} className="width-10">
                                                        <CheckboxElement
                                                            checked={myAccount.documentManagement[key]}
                                                            onChangeCheck={(e) => checkResponsibility(e.checked, key, 'documentManagement')}
                                                            className="mr-2"
                                                        />
                                                    </td>
                                                ))
                                            }
                                        </tr>
                                    </React.Fragment>
                                }
                            </tbody>
                        </table>
                    </div>
                }
            </div>
            <div className="col pr-0 d-flex justify-end">
                <ButtonElement className="save-button" type="submit" onClick={saveEmailNotifications} label="Update" />
            </div>
        </div>
    );
}

export default EmailNotifications;